//  ! 🔥 💪🏻 Bn Ramadan fullstack MERN project 2 ( E-commerce fullstack app )
//  ! " The end of this project is the completing of future successes and creativity , Just strive, be patient, commit and keep going. "
//  ! 🔥 💪🏻 Always forward ! 💪🏻 🔥
import p1_img from './product_12.png';
import p2_img from './product_35.png';
import p3_img from './product_14.png';
import p4_img from './product_8.png';
import p5_img from './product_15.png';
import p6_img from './product_2.png';
import p7_img from './product_17.png';
import p8_img from './product_28.png';

let new_collections = [
  {
    id: 12,
    name: "It is just an example of women's products",
    image: p1_img,
    new_price: 50.0,
    old_price: 80.5,
  },
  {
    id: 35,
    name: "It is just an example of kid's products",
    image: p2_img,
    new_price: 85.0,
    old_price: 120.5,
  },
  {
    id: 14,
    name: "It is just an example of men's products",
    image: p3_img,
    new_price: 60.0,
    old_price: 100.5,
  },
  {
    id: 8,
    name: "It is just an example of women's products",
    image: p4_img,
    new_price: 100.0,
    old_price: 150.0,
  },
  {
    id: 15,
    name: "It is just an example of men's products",
    image: p5_img,
    new_price: 50.0,
    old_price: 80.5,
  },
  {
    id: 2,
    name: "It is just an example of women's products",
    image: p6_img,
    new_price: 85.0,
    old_price: 120.5,
  },
  {
    id: 17,
    name: "It is just an example of men's products",
    image: p7_img,
    new_price: 60.0,
    old_price: 100.5,
  },
  {
    id: 28,
    name: "It is just an example of kid's products",
    image: p8_img,
    new_price: 100.0,
    old_price: 150.0,
  },
];

export default new_collections;
